// extracted by mini-css-extract-plugin
export var downArrow = "_hs-0";
export var infoTooltipIcon = "_hs-3";
export var label = "_hs-1";
export var optionCard = "_hs-4";
export var upArrow = "_hs-2";